import { createReducer, on } from '@ngrx/store';
import { TALKDESK_ACTIONS } from '../actions/talkdesk.actions';
import { TalkDeskState } from '../types';

export const talkdeskFeatureKey = 'talkdesk';

export const initialState: TalkDeskState = {
  chats: {},
  activeChatId: undefined,
};

export const talkdeskReducer = createReducer(
  initialState,
  on(TALKDESK_ACTIONS.initialize, (state) => ({
    ...state,
  })),
  on(TALKDESK_ACTIONS.toggleChatVisibility, (state, { chatId }) => {
    const chat = state.chats[chatId];
    if (!chat) {
      return state;
    }

    const updatedChat = {
      ...chat,
      isOpen: !chat.isOpen,
    };

    return {
      ...state,
      chats: {
        ...state.chats,
        [chatId]: updatedChat,
      },
      // If we're closing the active chat, clear the activeChatId
      activeChatId: updatedChat.isOpen
        ? chatId
        : state.activeChatId === chatId
          ? undefined
          : state.activeChatId,
    };
  }),

  on(TALKDESK_ACTIONS.openChat, (state, { chatId }) => {
    const chat = state.chats[chatId];
    if (!chat) {
      return state;
    }

    return {
      ...state,
      chats: {
        ...state.chats,
        [chatId]: {
          ...chat,
          isOpen: true,
        },
      },
      activeChatId: chatId,
    };
  }),

  on(TALKDESK_ACTIONS.closeChat, (state, { chatId }) => {
    const chat = state.chats[chatId];
    if (!chat) {
      return state;
    }

    return {
      ...state,
      chats: {
        ...state.chats,
        [chatId]: {
          ...chat,
          isOpen: false,
        },
      },
      activeChatId:
        state.activeChatId === chatId ? undefined : state.activeChatId,
    };
  }),

  on(TALKDESK_ACTIONS.closeAllChats, (state) => {
    const updatedChats = Object.entries(state.chats).reduce(
      (acc, [id, chat]) => ({
        ...acc,
        [id]: {
          ...chat,
          isOpen: false,
        },
      }),
      {},
    );

    return {
      ...state,
      chats: updatedChats,
      activeChatId: undefined,
    };
  }),

  on(TALKDESK_ACTIONS.setActiveChat, (state, { chatId }) => {
    const chat = state.chats[chatId];
    if (!chat) {
      return state;
    }

    return {
      ...state,
      activeChatId: chatId,
      chats: chat.isOpen
        ? state.chats
        : {
            ...state.chats,
            [chatId]: {
              ...chat,
              isOpen: true,
            },
          },
    };
  }),
);
